import axios from 'axios';

axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';

const _DEV = 0;
const _TESTE = 1;
const _PROD = 2;

const ambienteHCFamema = [
  'https://localhost:44302',
  'https://srvaplic2.famema.br/famemasistemasaspnetapiteste',
  'https://srvaplic2.famema.br/famemasistemasaspnetapi',
];
const ambienteOPERA = [
  'http://127.0.0.1:8000',
  'https://operamanagerhc2.famema.br:4577',
  'https://operamanagerhc.famema.br',
];
const ambienteNODE = [
  'http://127.0.0.1:3888',
  'https://operaloghc2.famema.br:3888',
  'https://operaloghc.famema.br:3887',
];

const ambienteOperaAspNet = [
  'http://localhost:44336',
  'https://srvaplic2.famema.br/OperaAspNetApiTeste',
  'https://srvaplic2.famema.br/OperaAspNetApi',
];

export const dominioDemandaCirurgica = axios.create({
  baseURL: ambienteOPERA[_PROD],
});

export const dominioHCFamema = axios.create({
  baseURL: ambienteHCFamema[_PROD],
});

export const dominioNODE = axios.create({
  baseURL: ambienteNODE[_PROD],
});

export const dominioOperaAspNet = axios.create({
  baseURL: ambienteOperaAspNet[_PROD],
});

export const caminhoArquivosServidor = `${ambienteOPERA[_PROD]}/media/documento`;
